import React, { useState, useCallback } from 'react';
import { fetchApkPresignedUrl } from '../services/apkService';

const AppCard: React.FC<{
  title: string;
  subtitle: string;
  imageSrc: string;
  imageAlt: string;
  variant: 'interna' | 'externa';
}> = ({ title, subtitle, imageSrc, imageAlt, variant }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onDownload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { url } = await fetchApkPresignedUrl(variant);
      window.location.assign(url);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'No se pudo iniciar la descarga');
    } finally {
      setLoading(false);
    }
  }, [variant]);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden flex flex-col max-w-md w-full">
      <div className="bg-gray-50 dark:bg-gray-900/50 flex justify-center p-6">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-40 h-40 object-contain rounded-xl shadow-md"
        />
      </div>
      <div className="p-6 flex flex-col flex-1 gap-3">
        <div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{title}</h2>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{subtitle}</p>
        </div>
        {error && (
          <p className="text-sm text-red-600 dark:text-red-400" role="alert">
            {error}
          </p>
        )}
        <div className="mt-auto pt-2">
          <button
            type="button"
            onClick={onDownload}
            disabled={loading}
            className="inline-flex justify-center items-center w-full rounded-lg bg-primary-600 hover:bg-primary-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-medium py-3 px-4 transition-colors"
          >
            {loading ? 'Generando enlace…' : 'Descargar APK'}
          </button>
        </div>
      </div>
    </div>
  );
};

const AppsDownloadPage: React.FC = () => {
  return (
    <div className="min-h-full w-full flex flex-col items-center py-10 px-4 sm:px-6">
      <div className="w-full max-w-4xl">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
              Apps Android
            </h1>
            <p className="mt-1 text-gray-600 dark:text-gray-400">
              Descargá la aplicación para tu rol. El enlace de descarga es temporal y seguro (URL
              firmada).
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-8 justify-center items-stretch">
          {/* interna/externa → GET /api/Apk/presigned/interna|externa → ObjectStorage:MobileApk:Interna|ExternaStorageKey */}
          <AppCard
            title="Incer Operaciones"
            subtitle="App para uso en campo y clientes."
            imageSrc="/incer-app.png"
            imageAlt="Incer Operaciones"
            variant="externa"
          />
          <AppCard
            title="Incer Colectores"
            subtitle="Para uso interno de la organización."
            imageSrc="/colectores-app.png"
            imageAlt="Incer Colectores"
            variant="interna"
          />
        </div>
      </div>
    </div>
  );
};

export default AppsDownloadPage;
